module.exports = __webpack_public_path__ + "img/jlfw.43312319.jpg";